//#region imports
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from '@app/member-response-portal/service/authentication.service';
import { InactivityTimerService } from '../services/inactivity-timer.service';
//#endregion imports

export const AuthGuard : CanActivateFn = async () => {
    const authenticationService : any = inject(AuthenticationService);
    const inactivityTimerService : any = inject(InactivityTimerService);

    let sessionIsValid: boolean;
    try {
        sessionIsValid = await authenticationService.IsSessionValid();
    } catch {
        authenticationService.UnauthorizedRedirectLogin();
        return false;
    }

    if(sessionIsValid){
        inactivityTimerService?.StartInactivityTimer();
    }

    return sessionIsValid;
}
